import { Injectable } from "@angular/core";
import { ApiHttpService } from "./api-http.service";
import { Observable } from "rxjs";

@Injectable()
export class FacilityNameService {
  constructor(private apiHttp: ApiHttpService) {}

  public getAll = (): Observable<FacilityName[]> => {
    return this.apiHttp.get<FacilityName[]>("facilities");
  };

  public get = (id: number): Observable<FacilityName> => {
    return this.apiHttp.get<FacilityName>(`facilities/${id}`);
  }
}

export interface FacilityName {
  id: number;
  name: string;
  isActive: boolean;
  facilityTypeId: number;
  order: number;
}


// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/shared/services/facility-name.service.ts